import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const SectionStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
`

export const DefinitionHint = styled.span`
  display: inline-flex;
  width: fit-content;
  cursor: help;
`

export const HoursCellWrap = styled.div`
  display: grid;
  grid-template-columns: 3rem minmax(6rem, 1fr);
  column-gap: 0.75rem;
  align-items: center;
  min-width: 12rem;
`

export const FootnoteWrap = styled.div`
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid ${tokens.border.hairline};
`
